// @flow

import React from 'react';
import { FormattedMessage } from 'react-intl';

import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { ModalBody } from 'dibs-elements/exports/ModalBody';
import { ModalCloseButton } from 'dibs-elements/exports/ModalCloseButton';
import { ModalContainer } from 'dibs-elements/exports/ModalContainer';

import DeleteProject from './DeleteProject';
import type { DeleteProjectProps } from './DeleteProject';

const messages = {
    title: (
        <FormattedMessage
            id="dc.ProjectForms.DeleteProjectModal.title"
            defaultMessage="Delete Project"
        />
    ),
};

type DeleteProjectModalProps = {|
    ...DeleteProjectProps,
    isOpen?: boolean,
    onClose: () => void,
|};

export function DeleteProjectModal(props: DeleteProjectModalProps) {
    const { isOpen, ...projectProps } = props;
    const { onClose } = props; // separate to inlude with project props
    return (
        <ModalContainer isOpen={!!isOpen} modalPosition="center" onClose={onClose}>
            <BarHeader title={messages.title} />
            <ModalCloseButton onClick={onClose} />
            <ModalBody>
                <DeleteProject {...projectProps} />
            </ModalBody>
        </ModalContainer>
    );
}

export default DeleteProjectModal;
